module.exports = __webpack_public_path__ + "static/media/sloga-slider-mobile.74ef8f4b.png";